import { createContext } from 'react';

export interface ResolvedSEO {
  title: string;
  description: string;
  canonical: string;
  ogType: string;
  ogImage: string;
  keywords?: string;
  schema?: Record<string, unknown>;
  noindex: boolean;
}

// A collector is provided only during static rendering. Browser pages update the head.
export const SeoCollectorContext = createContext<((seo: ResolvedSEO) => void) | null>(null);

